import { generateMarketPathname } from '@chewy/market-handler';
import { useQuery } from '@tanstack/react-query';

import { useMarket } from '@/providers/MarketProvider';
import { fetchGeneralContentPage } from '@/services/content-a/fetch-general-page';
import { getAssetPrefix } from '@/utils/marketHandler';

export const CMS_CONTENT_KEY = '/api/content/v1/pages/general/types/loyalty-sign-up';

/**
 *  Returns loyalty general cms content
 * @param shouldFetch should only be true when you want the service call to be executed
 * @returns
 */
export const useCmsContent = (shouldFetch = true, selectionKey: string | undefined = undefined) => {
  const { market } = useMarket();
  const queryKey = [`${generateMarketPathname(CMS_CONTENT_KEY, market)}`, selectionKey].filter(
    val => val,
  );

  const fetcher = () => fetchGeneralContentPage({ market, selectionKey });
  return useQuery({
    queryKey,
    queryFn: fetcher,
    enabled: shouldFetch,
    retry: false,
  });
};

useCmsContent.key = `${getAssetPrefix(CMS_CONTENT_KEY)}`;
